import React, { useReducer } from "react";
import PropTypes from "prop-types";

// AssetDownloadContext
import AssetDownloadContext from "core/AssetDownload/Context";
import { getDefaultState } from "core/AssetDownload/Context/getDefaultState";
import reducer from "core/AssetDownload/Context/reducer";

// components
import RootWrapper from "./components/RootWrapper";

import useFeatureFlag from "frontend/hooks/useFeatureFlag";
import { PREMIUM_PHOTOS_FLAG } from "frontend/data/featureFlags";

const AssetDownloadContent = ({
    assetType,
    asset,
    assetDownloadConfig,
    children
}) => {
    const hasPremiumPhotos = useFeatureFlag(PREMIUM_PHOTOS_FLAG);
    const [state, dispatch] = useReducer(reducer, {}, () =>
        getDefaultState({
            assetType,
            asset,
            assetDownloadConfig,
            hasPremiumPhotos
        })
    );

    return (
        <AssetDownloadContext.Provider
            value={{ state, dispatch }}
            displayName="Asset Download Content Context"
        >
            <RootWrapper>{children}</RootWrapper>
        </AssetDownloadContext.Provider>
    );
};

export default AssetDownloadContent;

// prop-types
AssetDownloadContent.propTypes = {
    assetType: PropTypes.string.isRequired,
    asset: PropTypes.object.isRequired,
    assetDownloadConfig: PropTypes.object.isRequired
};
